import { ProjectFilterContext } from '../../components/action-bar/project-picker/contexts';
import { ResourceFilterContext } from '../../components/action-bar/resource-picker/contexts';
import { filterContextHook } from './common';

export const useResourceFilterContext = filterContextHook(ResourceFilterContext);

export const useProjectFilterContext = filterContextHook(ProjectFilterContext);
